import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { QJumpersForm } from "@qjumpers/common-ui";
import schema from "./schema.json";
import uiSchema from "./uiSchema.json";
import PropTypes from "prop-types";
const WithdrawForm = props => {
  const { t } = useTranslation();
  const { onSubmit, onCancel } = props;
  const [initialValues] = useState( props.initialValues || {} );
  return (
    <span>
    { t("Application.Withdraw.Title.Message") }
    <QJumpersForm schema={schema} uiSchema={uiSchema} initialValues={initialValues} onSubmit={onSubmit} onCancel={onCancel} submitButtonText={ t("Action.Submit") } cancelButtonText={ t("Modal.Close") } />
  </span>
  )
}

WithdrawForm.propTypes = {
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func
}
export default WithdrawForm;